export default __webpack_public_path__ + "static/media/pinterest.528cdac4.svg";